// Copyright (c) Docugami, Inc. All rights reserved.

import { ProviderId, ProviderItem } from './StorageProviders';

export enum WorkPathEvaluationStatus {
    Ready = 'Ready',
    Evaluating = 'Evaluating',
    Paused = 'Paused',
    Error = 'Error'
}

export interface WorkPathEvaluationMessage {
    workPathId: string;
    configurationId: string;
    succeeded?: boolean;
}

export interface EvaluateWorkPathMessage {
    workPathId: string;
    succeeded?: boolean;
}

export interface CloneWorkPathEntriesResponse {
    workPath: WorkPath;
    reportId: string;
}

export interface CloneWorkPathEntriesRequest {
    sourceWorkPathId: string;
    operationId?: string;
    workPath: {
        name: string;
        clusterId: string;
        workPathType: WorkPathType;
    }
}

// Must be kept in-sync with WorkPath.cs
export enum WorkPathStatus {
    NotStarted = 'NotStarted',
    InProgress = 'InProgress',
    Blocked = 'Blocked',
    Complete = 'Complete'
}

// Must be kept in-sync with WorkPath.cs
export enum WorkPathType {
    TabularReport = 'TabularReport',
    Abstract = 'Abstract',
    ExcelExport = 'ExcelExport',
    AutomationAnywhereDocumentAssembly = 'AutomationAnywhereDocumentAssembly',
    AutomationAnywhereWorkFlow = 'AutomationAnywhereWorkFlow',
    UiPathWorkFlow = 'UiPathWorkFlow',
    UiPathDocumentAssembly = 'UiPathDocumentAssembly',
    DiligenceReport = 'DiligenceReport'
}

export enum WorkPathCategory {
    Understand = "Understand",
    Create = "Create",
    Workflow = "Workflow"
}

// Must be kept in-sync with ExportConfiguration.cs
export enum ExportConfigurationStatus {
    Uninitialized = 'Uninitialized',
    Ready = 'Ready',
    Error = 'Error'
}

// Must be kept in-sync with AddWorkPathExportConfigurationRequest.cs
export interface AddExportConfigurationRequest {
    providerId: ProviderId;
    destination: ProviderItem | null;
}

export interface BaseExportConfigurationRequest {
    configurationId: string;
}

export interface UpdateExportConfigurationRequest extends BaseExportConfigurationRequest {
    disabled?: boolean;
}

// Must be kept in-sync with ExportConfiguration.cs
export interface ExportConfiguration {
    id: string;
    providerId: ProviderId;
    destinationPath: string;
    ownerEmail: string;
    status: ExportConfigurationStatus;
    destination: ProviderItem | null;
    isDisabled: boolean;
    streamVersionWatermark: number | null;
    version: number;
}

// Must be kept in-sync with WorkPath.cs
export interface WorkPath {
    id: string;
    name: string;
    clusterId: string;
    version: string;
    createdAt: string;
    creatorEmail: string | undefined;
    lastModified: string;
    status: WorkPathStatus;
    workPathType: WorkPathType;
    resources: { [id: string]: string };
}

export interface SaveWorkPathResponse {
    workPath: WorkPath;
    reportId?: string;
    operationId?: string;
}

export interface CreateWorkPathRequest {
    docsetId: string;
    name: string;
    type: WorkPathType;
    maxSuggestedEntries?: number;
    resources?: { [id: string]: string };
}

// Must be kept in-sync with WorkPath.cs
export enum NamedResource {
    ReportId = 'report_id',
    DocumentId = 'document_id'
}

export enum DocSetCollectionType {
    User = 'User',
    Sample = 'Sample',
    All = 'All'
}
